import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { CheckIcon } from "../components";

function MarkAsCompleteButton(props) {
  const {
    content_group,
    updated_content_group,
    handleInlineEdit
  } = props;
  const [mark_as_complete, setAsComplete] = useState(content_group?.completed || false)
  const timeoutRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if(content_group?.completed !== mark_as_complete){
      setAsComplete(content_group?.completed);
      if (inputRef.current){
        inputRef.current.checked = content_group?.completed;
      }
    }
  }, [content_group?.completed]);

  const handleSubmit = (e) => {
    if(handleInlineEdit === undefined || handleInlineEdit === null) return;
    
    const checked = e.target.checked;
    setAsComplete(checked)

    if(timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      handleInlineEdit({completed: checked})
    }, 0);
  }

  return (
    <div className={`detail hoverable mark_as_complete-btn-container d-flex flex-column  ${mark_as_complete && 'completed'}`}>

      <label 
        className="mt-0 mark_as_complete-btn px-1 cursor-pointer d-flex align-items-center"
        style={{ flex: 1 }}
      >

        <div 
          className={`
            d-flex align-items-center justify-content-center
            rounded-checkbox
            rounded-checkbox--${mark_as_complete ? 'checked-white' : 'unchecked'}
            ms-1
          `}
        >
          {mark_as_complete && (
            <CheckIcon color="#0CF574" height={8} width={10} />
          )}
        </div>

        <div className="mark_as_complete-btn-check ">

          <input type="checkbox"
            name={`completed`}
            className={`d-none ${mark_as_complete ? 'checked' : ''}`}
            defaultChecked={mark_as_complete}
            onClick={(e) => {
              handleSubmit(e)
            }}
            ref={inputRef}
          />
        </div>
        <span className="ms-2 checkbox-text">{ mark_as_complete ? 'Marked as Completed' : 'Mark as Complete' }</span>
      </label>
    </div>

  );
}

const mapStateToProps = (state) => {
  return {
    updated_content_group: state.content_group.updated_content_group
  };
};

export default connect(mapStateToProps, { })(MarkAsCompleteButton);
